var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layered-background"},[_c('div',{staticClass:"positioner",style:(_vm.computedStyles)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }